import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	PetitionCreateMediaHit,
	type PetitionCreateMediaHitMutation,
	type PetitionCreateMediaHitMutationVariables,
} from './createMediaHit.graphql';

export async function createMediaHit(mediaLink: string, petitionId: string, utilityContext: UtilityContext) {
	const {
		gql: { fetch },
	} = utilityContext;

	const result = await fetch<PetitionCreateMediaHitMutation, PetitionCreateMediaHitMutationVariables>({
		query: PetitionCreateMediaHit,
		variables: {
			input: {
				petitionId,
				comment: mediaLink,
				role: 'MEDIA_HIT_COMMENT',
			},
		},
		rejectOnError: false,
	});

	return result.data?.createPetitionComment;
}
